export enum ApplicationProgressStatus {
    PENDING= 'PENDING',
    PROGRESS = 'PROGRESS',
    COMPLETE = 'COMPLETE'
}